import { render, staticRenderFns } from "./card-title.vue?vue&type=template&id=7243f45c&scoped=true&"
import script from "./card-title.vue?vue&type=script&setup=true&lang=ts&"
export * from "./card-title.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./card-title.vue?vue&type=style&index=0&id=7243f45c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7243f45c",
  null
  
)

export default component.exports